export default {
  countryCode: 'ZA',
  regionLinks: [
    {
      title: 'Cape Town',
    },
    {
      title: 'Durban',
    },
    {
      title: 'Johannesburg',
    },
    {
      title: 'Soweto',
    },
    {
      title: 'Pretoria',
    },
    {
      title: 'Port Elizabeth',
    },
    {
      title: 'Pietermaritzburg',
    },
    {
      title: 'Benoni',
    },
    {
      title: 'Tembisa',
    },
    {
      title: 'East London',
    },
  ],
};
